<!-- 租用车位-->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KPGBT6T",
                "billCode": "123123123123",
                "carCode": "粤TEST01",
                "phone": "",
                "shareFrom": "2018-04-11 12:00:00",
                "shareTo": "2018-04-13 12:00:00",
                "freeTime": "10",
                "shareValue": 10.00,
                "paySuccessDate": "2018-04-13 12:30:00"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台进行车位租用",
                t_url: this.commonUrls.test+"doLeasePot",
                p_url: this.commonUrls.prod+"doLeasePot",
                precondition: "VEMS 2.13及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '共享订单号（小于30位）' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '共享车牌号' },
                        { info1: 'parkingSpace', info2: '否', info3: 'String', info4: '共享车位编号' },
                        { info1: 'phone', info2: '否', info3: 'String', info4: '手机号' },
                        { info1: 'shareFrom', info2: '是', info3: 'String', info4: '起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'shareTo', info2: '否', info3: 'String', info4: '结束时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'freeTime', info2: '是', info3: 'String', info4: '免费离场时间（>=0的正数）' },
                        { info1: 'shareValue', info2: '是', info3: 'Decimal', info4: '停车费用（单位元）' },
                        { info1: 'paySuccessDate', info2: '是', info3: 'String', info4: '最后支付时间,yyyy-MM-dd HH:mm:ss' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/shareBooking/doLeasePot.vue